























































































































import { BaseRequisitesVue } from "fs-pb-vue2/vueModels/contracts/BaseRequisitesVue";
import DetailsList from "fs-pb-vue2/components/DetailsList.vue";
import { Component } from "vue-property-decorator";
import i18n from "@/i18n";

@Component({
  components: { DetailsList }
})
export default class Requisites extends BaseRequisitesVue {
  async mounted() {
    await this.init();
  }

  /** реквизиты счета */
  get details(): Array<any> {
    let bankDetails: Array<any> = [];
    if (this.bankDetails) {
      bankDetails = [
        {
          //Владелец Счета
          name: i18n.t("main.contracts.bankDetails.RecepientName"),
          isWrapped: true,
          textVal: this.bankDetails.RecepientName
        },
        {
          //Расчётный/Лицевой счёт
          name: i18n.t("main.contracts.bankDetails.Rs"),
          textVal: this.bankDetails.Rs
        },
        {
          //Банк получателя"
          name: i18n.t("main.contracts.bankDetails.BankName"),
          textVal: this.bankDetails.BankName
        },
        {
          //БИК
          name: i18n.t("main.contracts.bankDetails.Bik"),
          textVal: this.bankDetails.Bik
        },
        {
          //Корр. счёт
          name: i18n.t("main.contracts.bankDetails.Ks"),
          isWrapped: true,
          textVal: this.bankDetails.Ks
        },
        {
          //ИНН
          name: i18n.t("main.contracts.bankDetails.Inn"),
          textVal: this.bankDetails.PersonInn
        },
        {
          name: i18n.t("main.contracts.bankDetails.Info"),
          isWrapped: true,
          textVal: this.bankDetails.Info
        }
      ];
    }
    return bankDetails;
  }
}
